// extracted by mini-css-extract-plugin
module.exports = {"button":"TopicSpeedDropdown_button__seDPq","section-expanded":"TopicSpeedDropdown_section-expanded__PNCx2","section-collapsed":"TopicSpeedDropdown_section-collapsed__MwA40"};